import { environment } from '../../../../../environments/environment';
import { MissingArgumentsError } from '../../../../models/errors/general.errors';
import { IPaginationQuery } from '../../../../models/defines';
import OrganizationUrls from '../organization/organization.urls';
import { IWSContext } from '../../../../models/workspace/workspace-model';
import { IOrgContext } from '../../../../models/organization/organization-model';
import { getQueryString } from '../../../../utils/general-functions';

class WorkspaceUrls {
    public getWorkspaceAddUsersPUTUrl(wsContext: IWSContext) {
        return `${this.getDetailsWSUrl(wsContext)}/add-users`;
    }
    public getCreateWorkspacePOSTUrl(orgContext: IOrgContext) {
        return `${this.getWorkspaceUrl(orgContext)}`;
    }

    public getWorkspaceGETUrl(wsContext: IWSContext) {
        return this.getDetailsWSUrl(wsContext);
    }

    public getWorkspacesPaginatedGETUrl(orgContext: IOrgContext, options: IPaginationQuery): string {
        const baseOrganPath = OrganizationUrls.getDetailsOrganUrl(orgContext);
        const queryString = getQueryString(options);
        const searchParam = options.search
            ? `${queryString ? '&' : '?'}search=${encodeURIComponent(options.search)}`
            : '';
        return `${baseOrganPath}/workspace/list${queryString}${searchParam}`;
    }
    public getUsersInWorkspace(wsContext: IWSContext, pagination: IPaginationQuery): string {
        const params: string[] = [];

        if (pagination?.limit) {
            params.push(`limit=${pagination.limit}`);
        }

        if (pagination?.page) {
            params.push(`page=${pagination.page}`);
        }

        const queryString = params.length ? `?${params.join('&')}` : '';
        return `${this.getDetailsWSUrl(wsContext)}/users${queryString}`;
    }

    public getRemoveAssocItemDELETEUrl(wsContext: IWSContext) {
        return `${this.getDetailsWSUrl(wsContext)}/association`;
    }
    public getUpdateWSFieldsPUTUrl(wsContext: IWSContext) {
        return `${this.getDetailsWSUrl(wsContext)}`;
    }
    public getUpdateWSOrganDefaultIdsPUTUrl(wsContext: IWSContext) {
        return `${this.getDetailsWSUrl(wsContext)}/default`;
    }

    public getDetailsWSUrl(wsContext: IWSContext) {
        if (!wsContext || !wsContext.workspaceId) {
            throw new MissingArgumentsError('Could not get details workspace url because workspace id is null');
        }
        const bsaeUrl = this.getWorkspaceUrl({ organizationId: wsContext.organizationId });
        return `${bsaeUrl}/${wsContext.workspaceId}`;
    }
    private getWorkspaceUrl(orgContext: IOrgContext) {
        const baseOrganPath = OrganizationUrls.getDetailsOrganUrl(orgContext);
        return `${baseOrganPath}/workspace`;
    }
}

export default new WorkspaceUrls();
